export default __webpack_public_path__ + "static/media/checked.e332dfd8.svg";